import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectFeeSubHeadByFeeHead {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectFeeSubHeadByFeeHead = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectFeeSubHeadByFeeHead) => {
  const itemList = useStoreState((state) => state.saccount.feeSubHeadConfigurationList);

  
  const onSelect = (id) => {
    if (itemList) {
      onChange(id);
    }
  };

  // React.useEffect(() => {
  //   if (selected) {
  //     thanaListFetch(selected?.districtId);
  //   }
  // }, [selected])


  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      mode="multiple"
      placeholder="Select Fee Subhead"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.feeSubHeadId} value={type.feeSubHeadId}>
            {type.feeSubheadName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Fee Subhead</Option>
      )}
    </Select>
  );
};
